query getBookingRequests(
  $pagination: PaginationInput
  $checkInFrom: LocalDate
  $checkInTo: LocalDate
  $checkOutFrom: LocalDate
  $checkOutTo: LocalDate
  $regionIds: [UUID!]
  $term: String
  $statuses: [RequestStatus!]
  $sources: [LeadSource!]
) {
  getBookingRequests: adjustmentRequests {
    _: bookingRequests(
      pagination: $pagination
      checkInFrom: $checkInFrom
      checkInTo: $checkInTo
      checkOutFrom: $checkOutFrom
      checkOutTo: $checkOutTo
      regionIds: $regionIds
      term: $term
      statuses: $statuses
      sources: $sources
    ) {
      pages
      total
      results {
        booking {
          id
          checkIn
          checkOut
          hash
          guests
          source
          guestAcronymName
          folio {
            summary {
              total
              balance
            }
          }
          home {
            name
            revenueModel
            region {
              name
            }
          }
        }
        status
        requests {
          id
          amounts {
            requested
            approved
            refundedAt
          }
          reason {
            name
            description
            group {
              name
            }
          }
          createdAt
          createdBy {
            name
          }
          reviewedAt
          reviewedBy {
            name
          }
          statesHistory {
            author {
              name
            }
            note
          }
          requestedAmount
        }
        totalRequested
      }
    }
  }
}
